<template>
  <b-modal
    :id="modalId"
    centered
    title="Add Coaching"
    @hide="$emit('close')"
    hide-header-close
    @show="resetModal"
    @hidden="onHidden"
    @ok.prevent="handleOk"
    size="lg"
  >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row>
        <b-col class="col-6">
          <b-form-group label="Competency" :state="getState('competency_id')" invalid-feedback="Competency is required.">
            <v-select
              v-model="form.competency_id"
              :options="competencyOptions"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-6">
          <b-form-group
            label="Coaching / Mentoring"
            :state="getState('coaching_id')"
            invalid-feedback="Coaching / Mentoring is required."
          >
            <v-select
              v-model="form.coaching_id"
              :options="coachingOptions"
              label="title"
              :reduce="(e) => e.id"
              placeholder="Select Coaching / Mentoring"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <template #modal-footer>
      <b-button
        variant="primary"
        @click="handleOk"
        :disabled="isLoading || !form.competency_id || !form.coaching_id"
        :key="isLoading"
      >
        <b-spinner v-if="isLoading" small type="grow" class="me-2"></b-spinner>
        <span>{{ isLoading ? "Submitting..." : "Submit" }}</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AddCoachingModal",

  props: {
    modalId: { type: String, default: "add-coaching-modal" },
    competencyOptions: { type: Array, default: () => [] },
    coachingOptions: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    // fetchCoachingOptions removed: child will emit event instead
  },

  data() {
    return {
      form: this.getInitialForm(),
      submitted: false,
      formErrors: {},
      suppressValidation: false,
    };
  },

  watch: {
    "form.competency_id": async function (val, oldVal) {
      if (val === oldVal) return;
      this.form.coaching_id = null;
      await this.getListCoaching(val);
    },
  },

  methods: {
    getState(field) {
      if (this.formErrors[field]) return false;
      return null;
    },

    onHidden() {
      this.resetModal();
      this.$emit("close");
    },

    async getListCoaching(id) {
      if (!id) return;
      this.$emit("fetch-coaching", id);
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },

    validateAll() {
      this.formErrors = {};

      if (!this.form.competency_id) this.formErrors.competency_id = "Competency is required.";

      if (!this.form.coaching_id) this.formErrors.coaching_id = "Coaching is required.";

      return Object.keys(this.formErrors).length === 0;
    },

    handleSubmit() {
      const isValid = this.validateAll();
      if (!isValid) return;

      const payload = {
        competency_id: this.form.competency_id,
        coaching_id: this.form.coaching_id,
      };

      this.$emit("add-coaching", payload);
    },

    getInitialForm() {
      return {
        competency_id: null,
        coaching_id: null,
      };
    },

    async resetModal() {
      if (this.isLoading) return;

      this.suppressValidation = true;

      await this.$nextTick();

      this.form = this.getInitialForm();
      this.formErrors = {};

      this.$nextTick(() => {
        this.suppressValidation = false;
      });
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

.me-1 {
  margin-right: 0.25rem;
}

.me-2 {
  margin-right: 0.5rem;
}

.me-3 {
  margin-right: 1rem;
}
</style>
